import { structureMenuParser } from '@/assets/scripts/parsers/menu'

/** saves menu info in our store
@payload { object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_menu
*/
export const SAVE_MENU_INFO = (state, payload) => {
    state.menu = structureMenuParser(payload)
}

/** saves submenu info in our store
@payload { array }
*/
export const SAVE_SUB_MENU_INFO = (state, payload) => {
    state.submenu = payload.subMenuItemViewList
}
